import { Injectable,Injector } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ConfigurationService } from '../common/configuration.service';
import{ AuthService }from '../common/auth.service';
@Injectable()
export class FileUploadService {
  private readonly _postUrl: string = "/api/fileupload/create";
  private get postUrl() { return this.configurations.baseUrl + this._postUrl; }
  constructor(public http: Http,public authService:AuthService, public  configurations: ConfigurationService, injector: Injector) {
   
  }

  upload(formData: FormData,param:any) {
    let headers = new Headers();
    headers.append('Authorization', 'Bearer ' + this.authService.accessToken);
    let options = new RequestOptions({ headers: headers });
    options.params = param;
    return  this.http.post(this.postUrl, formData, options)
             .map(response => response.json())
             .catch(error => Observable.throw(error));
    //return this.http.post(this.postUrl, JSON.stringify(param), this.getRequestHeaders()).catch(error => { return this.handleError(error, () => this.upload(formData,param)); })
  }
}



// WEBPACK FOOTER //
// D:/Projects/Empower360Plus/EmpowerWeb2.0/A4.Empower/A4.Empower/ClientApp/src/app/services/file-upload/file-upload.service.ts